import React from "react";
import { BasePopup } from "./BasePopup";
import AssetRegister from "pages/AssetRecovery/Assets/AddAsset";
import { Referral } from "types";

export default function AddReferralAssetPopup({
  isOpen,
  onClose,
  id,
  referralData,
  setActiveTab,
  //   setShowAddAssetForm,
  handleAssetCreated,
}: {
  onClose: () => void;
  isOpen: boolean;
  id: string;
  referralData: Referral;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
  handleAssetCreated: () => void;
}) {
  return (
    <BasePopup
      isOpen={isOpen}
      onClose={onClose}
      title="Add Asset"
      description="Please fill in the asset registration form details below."
      w="900px"
    >
      <AssetRegister
        referralId={id}
        referral={referralData}
        setActiveTab={setActiveTab}
        // setShowAddAssetForm={setShowAddAssetForm}
        onAssetCreated={handleAssetCreated}
      />
    </BasePopup>
  );
}
